<template>
  <app-slide>
    <article class="home" id="start">
        <div class="container">
          <div class="row full-height center-xs top-xs">
              <div class="col-xs-12 no-padding text-content">
                  <!-- <app-home-riboca></app-home-riboca> -->
                  <img src="static/RIBOCA_01_AD_HomepageBanner_750x1334_Art.png" alt="" class="img-home"/>
              </div>
          </div>
        </div>
    </article>
  </app-slide>
</template>


<script>
  import {store} from '../store/store'
  import HomeRiboca from '../components/HomeRiboca'
  import appSlide from '../transitions/AppSlide'
  import mixinLanguages from '../mixins/Language'
  export default {
    name: 'home',
    components: {
      appHomeRiboca: HomeRiboca,
      appSlide
    },
    computed: {

    },
    mixins: [mixinLanguages],
    data() {
      return {
        active: false,
        ribocaText:'',
        informationText:'',
        ribocaitems:'',
        appLanguages:'',
      }
    },
    mounted () {
      let baseUrl = this.$store.getters.getBaseUrl;
      let lang = this.$store.getters.getLangState;
      let url = baseUrl + '/' + lang + '/api/v1/riboca.json';
      let homeUrl = baseUrl + '/' + lang + '/api/v1/home.json';
      store.dispatch('setDestUrl', '__/__');
      store.dispatch('setDestChange', false);
      this.getContent(homeUrl);
      this.getItems(url);
      // this.$store.dispatch('setTransitionState',true);
    },
    computed:{
      // use a computed property to get the value from the store
      lang() { 
        return this.$store.state.langUrl;
      },
    },
    watch: {
      // use the watch to react on the value change.
      lang(newValue) {
        let baseUrl = this.$store.getters.getBaseUrl;
        let lang = this.$store.getters.getLangState;
        let url = baseUrl + '/' + lang + '/api/v1/riboca.json';
        let homeUrl = baseUrl + '/' + lang + '/api/v1/home.json';
        this.getContent(homeUrl);
        this.getItems(url);
      },
    },
    methods: {
      checkMenuState() {
        if (store.getters.getMenuState) {
          store.dispatch('setMenuState');
        }
      },
      getContent: function(url) {
        this.$http.get(url).then((response) => {
          this.ribocaText = response.body.riboca;
        });
      },
      getItems: function(url) {
        this.$http.get(url).then((response) => {
          this.ribocaitems = response.data.data;
        })
      }
    }
  }
</script>

<style lang="scss">
  $link-size: 1rem;
  .home {
    margin-top: 60px;
  }
  h1 {
    color:black;
  }
  .img-home {
    height: 80vh;
    width: auto;
    margin: 0 auto;
  }
  .screen {
    width: 100%;
    height: 100vh;
    .container {
      padding: 0 2rem;
    }
  }
  .home {
    p {
      color:white;
    }
  }
  .bg-image {
    background-position: center;
    background-size: cover;
    background-color: black;
    background-image: url('/static/riboca-home-left.jpg');
  }
  .full-height {
    height: 100vh;
  }
  .menu-nav {
  ul {
    list-style: none;
    margin-left: 0;
    padding-left: 0;
  }
  li {
    list-style: none;
    padding-top: 0.2em;
    padding-bottom: 0.2em;
  }
  a {
    text-decoration: none;
    border-bottom: 1px solid rgba(255,255,255,0);
    transition: border 0.3s ease-out;
    color: white;
    font-family: 'UniversLTPro-55Roman';
    &:hover {
      border-bottom: 1px solid black;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue